import { useState, useEffect } from 'react';
import axios from 'axios';
import { ChevronDown, Building, Check } from 'lucide-react';
import { toast } from 'sonner';

const StructureSwitcher = ({ user }) => {
  const [structures, setStructures] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (user?.role !== 'entreprise') return;
    axios.get('/me/structures').then(res => setStructures(res.data || [])).catch(() => {});
  }, [user]);

  if (!user || user.role !== 'entreprise' || structures.length <= 1) return null;

  const current = structures.find(s => s.user_id === user.user_id) || structures[0];

  const switchTo = async (sid) => {
    if (sid === user.user_id) { setOpen(false); return; }
    try {
      const res = await axios.post('/me/switch-structure', { structure_id: sid });
      const { access_token, user: targetUser } = res.data;
      localStorage.setItem('token', access_token);
      localStorage.setItem('user', JSON.stringify(targetUser));
      toast.success(`Structure "${targetUser.nom || ''}" activée`);
      window.location.href = '/';
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erreur');
    }
  };

  return (
    <div className="relative" data-testid="structure-switcher">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-3 py-1.5 bg-white/10 hover:bg-white/20 rounded-lg text-white text-sm transition-colors"
      >
        <Building className="h-4 w-4" />
        <span className="font-medium truncate max-w-[150px]">{current?.nom_entreprise || 'Structure'}</span>
        <ChevronDown className={`h-4 w-4 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-full mt-1 w-72 bg-white rounded-lg shadow-xl border border-slate-200 z-50 overflow-hidden">
            <div className="px-4 py-2 bg-slate-50 border-b border-slate-200 text-xs text-slate-500 uppercase tracking-wide font-medium">
              Mes structures
            </div>
            {structures.map(s => (
              <button
                key={s.user_id}
                onClick={() => switchTo(s.user_id)}
                className={`w-full text-left px-4 py-3 hover:bg-[#8DC63F]/10 transition-colors flex items-center justify-between gap-2 ${s.user_id === user.user_id ? 'bg-[#8DC63F]/5' : ''}`}
                data-testid={`switcher-item-${s.user_id}`}
              >
                <div className="min-w-0">
                  <p className="font-medium text-[#0F172A] truncate">{s.nom_entreprise}</p>
                  {s.siret && <p className="text-xs text-slate-500">SIRET : {s.siret}</p>}
                </div>
                {s.user_id === user.user_id && <Check className="h-4 w-4 text-[#8DC63F] shrink-0" />}
              </button>
            ))}
            <a href="/mes-structures" className="block px-4 py-3 text-sm text-blue-600 hover:bg-blue-50 border-t border-slate-200 text-center font-medium">
              Gérer mes structures →
            </a>
          </div>
        </>
      )}
    </div>
  );
};

export default StructureSwitcher;
